// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { layoutStyles } from "@adl/App/Widgets/ProductList/ProductListLayout";
import { color, xScreen } from "@adl/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

layoutStyles.container = {
    gap: 22,
    css: css`
        margin-top: 0px;
    `,
};

layoutStyles.columnStyles = {
    leftColumnGridItem: {
        width: [12, 12, 12, 3, 3],
        css: css`
            div[class^="FormFieldStyle"]:has(label[data-test-selector="productListSortSelect-label"]) {
                ${xScreen("gt", "md")} {
                    display: none;
                }
            }
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 9, 9],
        css: css`
            flex-direction: column;
        `,
    },
};

layoutStyles.mainSectionStyles = {
    wrapper: {
        css: css`
            width: 100%;
        `,
    },
    actionsContainer: {
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-top: 12px;
            margin-bottom: 22px;
            ${xScreen("lte", 600)} {
                flex-direction: column;
                align-items: flex-start;
                > div:not(:last-child) {
                    margin-bottom: 8px;
                }
            }
        `,
    },
    actionsContainerLeftSide: {
        css: css`
            display: flex;
            width: 50%;
            > div {
                width: auto;
                &:first-child {
                    margin-right: 22px;
                }
            }
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        `,
    },
    actionsContainerRightSide: {
        css: css`
            display: flex;
            justify-content: flex-end;
            width: 50%;
            > div {
                width: auto;
                &:first-child {
                    margin-right: 90px;
                }
            }
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        `,
    },
};

layoutStyles.mobileStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    contentsWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            justify-content: space-between;
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 24px;
            margin-bottom: 24px;
            ${TypographyStyle} {
                margin-bottom: 0;
            }
            ${xScreen("lte", "md")} {
                padding-bottom: 12px;
            }
        `,
    },
};

layoutStyles.modal = {
    cssOverrides: {
        titleButton: css`
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 30px;
            outline: none;
            border: 1px solid ${color("primary")};
            background-color: ${color("transparent")};
            color: ${color("primary")};
            border-radius: 2px;
            padding: 8px 24px;
            &:before {
                content: "Close";
                font-size: 10px;
                line-height: 11px;
                font-weight: bold;
            }
            &&& {
                top: 23px;
            }
            &&&&:hover:not(:disabled) {
                border-color: ${color("common.ui1")};
                color: ${color("common.ui1")};
            }
            &&&&:focus:not(:disabled),
            &&&&:active:not(:disabled) {
                outline: none;
                border-color: ${color("common.ui2")};
                color: ${color("common.ui2")};
            }
        `,
        modalContainer: css`
            ${xScreen("lte", "xs")} {
                > div {
                    height: 100%;
                    max-height: 100%;
                    margin: 0;
                }
            }
        `,
    },
    closeButtonIconProps: {
        css: css`
            display: none;
        `,
    },
};

layoutStyles.sortSection = {
    css: css`
        padding: 12px;
        border: 1px solid ${color("common.border")};
        width: 100%;
        margin: 10px 0;
        > div {
            display: flex;
            justify-content: space-between;
            > div {
                margin-top: 0;
                width: calc(50% - 8px);
                span {
                    width: 100%;
                }
                ${xScreen("lte", "xs")} {
                    width: calc(50% - 12px);
                }
            }
        }
    `,
};

layoutStyles.filterWrapper = {
    width: 12,
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
